import React from 'react'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SchoolIcon from '@mui/icons-material/School';
import HouseIcon from '@mui/icons-material/House';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import RecommendIcon from '@mui/icons-material/Recommend';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import user from '../assets/Nazirul Mobin.jpg'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import CommentIcon from '@mui/icons-material/Comment';
import ShareIcon from '@mui/icons-material/Share';

function Home(props) {
  const { dark } = props;

  return (
    <div className="grid lg:grid-cols-2 md:grid-cols-1 gap-4">
      <div>
        <div className={`flex items-center font-semibold border rounded-lg ${dark ? 'text-white' : 'bg-white'} p-5 mb-4 shadow-md shadow-purple-300`}>
          <RecommendIcon fontSize='large' sx={{ color: '#0066ff' }} />
          <div className='ml-3'>
            <p className='text-lg'>Welcome To My Portfolio Everyone</p>
            <p className='text-blue-700 cursor-pointer'>Learn More</p>
          </div>
        </div>

        <div className={`border rounded-lg ${dark ? 'text-white' : 'bg-white'} p-5 shadow-md shadow-purple-300`}>
          <p className='text-xl font-bold mb-3'>Intro</p>
          <p className='text-center border-b-2 pb-3 mb-3'>
            Competitive Programmer | Problem Solver | Self Learner | MERN Stack Dev | SQA Engineer
          </p>
          <div className='flex mb-3'>
            <BusinessCenterIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>Works at <span className='font-semibold'>Beginner Learning Academy</span></p>
          </div>
          <div className='flex mb-3'>
            <SchoolIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>Studies <span className='font-semibold'>MBA in Management Studies</span> at <span className='font-semibold'>Jagannath University</span></p>
          </div>
          <div className='flex mb-3'>
            <SchoolIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>Studied <span className='font-semibold'>B.Sc. in CSE</span> at <span className='font-semibold'>University of Information Technology and Sciences (UITS)</span></p>
          </div>
          <div className='flex mb-3'>
            <HouseIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>Lives in <span className='font-semibold'>Dhaka, Bangladesh</span></p>
          </div>
          <div className='flex mb-3'>
            <LocationOnIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>From <span className='font-semibold'>Dhaka, Bangladesh</span></p>
          </div>
          <div className='flex mb-3'>
            <FavoriteIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>Status Single</p>
          </div>
          <div className='flex mb-3'>
            <PhoneAndroidIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>+8801876678984</p>
          </div>
          <div className='flex mb-3'>
            <EmailIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>mdnazirulmobinahamed@gmail.com</p>
          </div>
          <div className='flex'>
            <RssFeedIcon sx={{ color: 'gray' }} />
            <p className='ml-2'>Followed by <span className='font-semibold'>500+ people</span></p>
          </div>
        </div>
      </div>

      <div>
        <div className={`border rounded-lg ${dark ? 'text-white' : 'bg-white'} p-3 mb-4 shadow-md shadow-purple-300`}>
          <div className='flex border-b pb-3'>
            <img src={user} alt='User' className='w-12 h-12 rounded-full border' />
            <input type='text' className='bg-gray-200 hover:bg-gray-300 w-full ml-3 text-lg pl-3 rounded-full cursor-pointer' disabled placeholder='Write something to Md. Nazirul...' />
          </div>
          <div className='grid grid-cols-3 pt-3'>
            <div className={`flex  justify-center cursor-pointer ${dark && 'hover:text-gray-800'} hover:bg-gray-200 p-2 rounded w-full`}>
              <AddPhotoAlternateIcon sx={{ color: '#00cc44' }} />
              <p className='ml-1'>Photo/video</p>
            </div>
            <div className={`flex  justify-center cursor-pointer ${dark && 'hover:text-gray-800'} hover:bg-gray-200 p-2 rounded w-full`}>
              <LocalOfferIcon sx={{ color: '#0066ff' }} />
              <p className='ml-1'>Tag people</p>
            </div>
            <div className={`flex  justify-center cursor-pointer ${dark && 'hover:text-gray-800'} hover:bg-gray-200 p-2 rounded w-full`}>
              <InsertEmoticonIcon sx={{ color: '#ffd633' }} />
              <p className='ml-1'>Feeling/activity</p>
            </div>
          </div>
        </div>

        <div className={`border rounded-lg ${dark ? 'text-white' : 'bg-white'} p-3 mt-4 shadow-md shadow-purple-300`}>
          <div className='flex pb-3'>
            <img src={user} alt='User' className='w-12 h-12 rounded-full border' />
            <div className='ml-3'>
              <p className='font-semibold'>Md. Nazirul Mobin Ahamed</p>
              <p className='text-gray-500 font-semibold' style={{ fontSize: '12px' }}>December 1 of 2025 at 12:01 AM</p>
            </div>
          </div>
          <div className='border-b pb-2'>
            <p className='text-xl'>
              Hello, I am Md. Nazirul Mobin Ahamed. I am a passionate software developer and tester.
              I have experience with real world MERN stack applications like
              Ecommerce website and Social Media website etc. with manual and automated testing.
              If you are interested then feel free to reach me.
            </p>
          </div>
          <div className='grid grid-cols-3 pt-2'>
            <div className={`flex justify-center cursor-pointer ${dark && 'hover:text-gray-800'} hover:bg-gray-200 p-2 rounded w-full`}>
              <ThumbUpOffAltIcon sx={{ color: 'gray' }} />
              <p className='ml-1'>Like</p>
            </div>
            <div className={`flex justify-center cursor-pointer ${dark && 'hover:text-gray-800'} hover:bg-gray-200 p-2 rounded w-full`}>
              <CommentIcon sx={{ color: 'gray' }} />
              <p className='ml-1'>Comment</p>
            </div>
            <div className={`flex justify-center cursor-pointer ${dark && 'hover:text-gray-800'} hover:bg-gray-200 p-2 rounded w-full`}>
              <ShareIcon sx={{ color: 'gray' }} />
              <p className='ml-1'>Share</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
